
































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class NoticeLinkModal extends Vue {
  @Prop({ default: '' })
  private modalName!: string;
  @Emit('beforeClose')
  beforeClose(event: any) {}
}
